module.exports = __webpack_public_path__ + "img/1-B-exploration-drilling.fc5b1938.png";